<template>
  <section id="group-persistance">
    <section class="content">
        <header><button href="#" class="btn" @click="savePersistantGroup">Spara namnlista</button></header>
        <article class="group" v-for="group of storedGroups" :key="group.id" >
          <aside @click="selectStoredGroup(group)">
            <h2>{{ group.name }}</h2>
            <p class="members">{{ group.members.length }} medlemmar</p>
          </aside>
          <aside>
            <img class="close" src="@/assets/check.svg" alt="close" @click="removeGroup(group.id)">
          </aside>
        </article>
    </section>
  </section>
</template>

<script>
export default {
    name: 'GroupPersistance',
    computed: {
      storedGroups(){
          return this.$store.state.persistentGroups;
      }
    },
    methods: {
      selectStoredGroup(group){

        this.$store.commit('updateRoster', group.members.join('\n'));
        this.$store.commit('configMenuUI', { close: false, navicon: true });
        this.$store.commit('toggleGroupPersistance');

      },
      async savePersistantGroup(){
        let name = prompt('Döp gruppen.');
        await this.$store.dispatch('savePersistentGroup', {members: this.$store.state.roster, name: name });
      },
      async removeGroup(id){
        if (confirm('Nu tar du bort gruppen, helt säker på det?')) {
          await this.$store.dispatch('deletePersistentGroup', id);
        }
      }
    },
    beforeMount(){
      this.$store.dispatch('readPersistentGroups');
    }
}
</script>

<style lang="scss">
@import './../scss/variables';
@import './../scss/components';

#group-persistance {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,.9);
  z-index: 999;
  display: flex;
  
  > .content {
    margin: auto;
    max-width: 800px;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    color: white;
    padding: 1rem;

    @media (max-width: 480px) {
      grid-template-columns: repeat(1, 1fr);
    }

    header {
      grid-column: auto / span 3;

      .btn:hover {
        background: white;
        color: #222;
      }

      @media (max-width: 480px) {
        grid-column: auto / span 1;
      }
    }

    .group {
      background: rgba(255,255,255,.15);
      padding: .25rem;
      border-radius: $radius;
      position: relative;
      transition: all .2s ease;
      display: flex;
      align-items: stretch;

      > aside:first-child {
        flex: 1;
        padding: .75rem;
      }

      > aside:last-child {
        width: 2rem;
        display: flex;
        justify-content: flex-end;
        align-content: flex-start;
      }

      &:hover {
        background: white;
        color: black;
        cursor: pointer;
        transform: scale(1.05);
        box-shadow: 0 0 3rem rgba(0,0,0,.1);

        img.close {
          filter:invert(1);
        }
      }

      img.close {
        border-radius: 2px;
        width: 1.5rem;
        height: 1.5rem;
        transition: background .2s ease;
        
        &:hover {
          background: rgba(255,255,255,.15);
        }
      }

      h2 {
        font-size: $font-mid;
        font-weight: 700;
      }

      > .members {
        font-weight: 500;
        font-size: .9rem;
        margin: .25rem 0;
      }
    }
  }
}

</style>